import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameGeometry";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
import SummerAr from "./SummerAr";
import SummerRe from "./SummerRe";
import SummerBlock from "./SummerBlock";

import AutumnAr from "./AutumnAr";
import AutumnRe from "./AutumnRe";
import AutumnBlock from "./AutumnBlock";

import SpringAr from "./SpringAr";
import SpringRe from "./SpringRe";
import SpringBlock from "./SpringBlock";

import Spag from "./Spag";
import SpagOutwood from "./SpagOutwood";

//NEW
import MTCLimit from "../MTC/MTCLimited";
import MTC from "../MTC/Practice";
import NumberBonds from "../Addition/NET";

//NEWSPELLING
import NewSpelling from "../Spelling/Assessments";
//NEWGRAMMAR
import NewGrammar from "../Grammar/Assessment";

//ARITHMETIC
import Arithmetic from "./Arithmetic";

//KS1FIXED
import KS1Fixed from "./KS1Fixed";

import ReadyToProgress from "./ReadyToProgress";


import { navigate } from "@reach/router";


//THIS IS THE START, it goes BASIC -> SUMMERAR -> PRACTICEGAMEASSESSMENT
export default function Basic({ ...props }) {


  function GetType() {
    let assessment_type = props.homework.assessment_type.split("_");
    console.log(assessment_type);


    if (props.homework.assessment_type && props.homework.assessment_type.toLowerCase().includes("newspelling")) {

      const assessmentId = props.homework.assessment_type.replace("newspelling_", "");

      console.log("Loading Spelling Assessment:", assessmentId);

      return (
        <NewSpelling
          {...props}
          assessment_id={assessmentId}
          homework_id={props.homework.id}
          gameData={props.game}
          level={props.homework.level || 1}
          onBack={() => {
            navigate(`/games/`);
          }}
        />
      );
    }


     if (props.homework.assessment_type && props.homework.assessment_type.toLowerCase().includes("grammar_")) {

      const assessmentId = props.homework.assessment_type;

      console.log("Loading Grammar Assessment:", assessmentId);

      return (
        <NewGrammar
          {...props}
          assessment_id={assessmentId}
          homework_id={props.homework.id}
          gameData={props.game}
          level={props.homework.level || 1}
          onBack={() => {
            navigate(`/games/`);
          }}
        />
      );
    }

    //FIRST CHECK MTC ETC
    if (assessment_type == "mtcnetlimited" || assessment_type == "mtcnetlimited|access") {
      var possibleNumbers = [2, 3, 5, 10];
      var questionCount = 25;

      return (
        <MTCLimit
          options={props.homework.options}
          possibleNumbers={possibleNumbers}
          questionCount={questionCount}
          timer={12}
          access={props.homework.assessment_type.replace("mtcnetlimited", "").replace("|", "")}
          game={props.game}
          gameType={props.game.game_type}
          homework_id={props.homework.id}
          onBack={() => {
            navigate(`/games/`);
          }}
        />
      )

    }
    if (assessment_type == "mtcnetlimited3" || assessment_type == "mtcnetlimited3|access") {
      var possibleNumbers = [2, 5, 10];
      var questionCount = 25;

      return (
        <MTCLimit
          options={props.homework.options}
          possibleNumbers={possibleNumbers}
          questionCount={questionCount}
          timer={12}
          access={props.homework.assessment_type.replace("mtcnetlimited3", "").replace("|", "")}
          game={props.game}
          gameType={props.game.game_type}
          homework_id={props.homework.id}
          onBack={() => {
            navigate(`/games/`);
          }}
        />
      )

    }

    if (assessment_type == "mtcnetlimited2" || assessment_type == "mtcnetlimited2|access") {
      var possibleNumbers = [2, 3, 4, 5, 8, 10];
      var questionCount = 25;

      return (

        <MTCLimit
          options={props.homework.options}
          possibleNumbers={possibleNumbers}
          questionCount={questionCount}
          timer={12}
          access={props.homework.assessment_type.replace("mtcnetlimited2", "").replace("|", "")}
          game={props.game}
          gameType={props.game.game_type}
          homework_id={props.homework.id}
          onBack={() => {
            navigate(`/games/`);
          }}
        />
      )

    }
    if (assessment_type == "mtcnet" || assessment_type == "mtcnet|access") {

      let topics = []
      for (let i = 0; i < props.homework.topics.length; i++) {
        const element = props.homework.topics[i];
        topics.push(element.topic_key.replace("MTC", ""));
      }

      console.log(topics);

      return (
        <MTC
          options={props.homework.options}
          noexit={true}
          access={props.homework.assessment_type.replace("mtcnet", "").replace("|", "")}
          topics={topics}
          timer={12}
          game={props.game}
          gameType={props.game.game_type}
          homework_id={props.homework.id}
          onBack={() => {
            navigate(`/games/`);
          }}
        ></MTC>
      )
    }
    if (assessment_type == "mtc6" || assessment_type == "mtc6|access") {

      let topics = []
      for (let i = 0; i < props.homework.topics.length; i++) {
        const element = props.homework.topics[i];
        topics.push(element.topic_key.replace("MTC", ""));
      }

      console.log(topics);

      return (
        <MTC
          options={props.homework.options}
          noexit={true}
          access={props.homework.assessment_type.replace("mtc6", "").replace("|", "")}
          topics={topics}
          timer={6}
          game={props.game}
          gameType={props.game.game_type}
          homework_id={props.homework.id}
          onBack={() => {
            navigate(`/games/`);
          }}
        ></MTC>
      )
    }

    var mtcfixeddtype = props.homework.assessment_type.split("|");

    if (mtcfixeddtype[0] == "mtcfixed") {

      let topics = []
      for (let i = 0; i < props.homework.topics.length; i++) {
        const element = props.homework.topics[i];
        topics.push(element.topic_key.replace("MTC", ""));
      }

      console.log(topics);
      var access = "";

      let opt = props.homework.options.split("|");
      if (opt.includes("access")) {
        access = "access";
      }

      let fixedtimer = 6;
      if (mtcfixeddtype[1] == "3"){
        fixedtimer = 12;
      }

      console.log(access);

      return (
        <MTC
          htype={props.homework.assessment_type}
          options={props.homework.options}
          noexit={true}
          access={access}
          topics={topics}
          timer={fixedtimer}
          game={props.game}
          gameType={props.game.game_type}
          homework_id={props.homework.id}
          onBack={() => {
            navigate(`/games/`);
          }}
        />
      )
    }

    if (assessment_type == "numberbonds1020") {

      let topics = []
      for (let i = 0; i < props.homework.topics.length; i++) {
        const element = props.homework.topics[i];
        topics.push(element.topic_key.replace("MTC", ""));
      }

      return (
        <Scale scaleTo={2500}>
          <NumberBonds
            noexit={true}
            topics={topics}
            timer={6}
            game={props.game}
            gameType={props.game.game_type}
            homework_id={props.homework.id}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    }

    if (assessment_type[2].toLowerCase() == "summer" && assessment_type[3] == "ar") {//arithmetic summer assignment
      return (
        <Scale scaleTo={2500}>
          <SummerAr
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    } else if (assessment_type[2].toLowerCase() == "summer" && assessment_type[3] == "re") {
      return (
        <Scale scaleTo={2500}>
          <SummerRe
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>)
    } else if (assessment_type[2].toLowerCase() == "summer" && assessment_type[3] != "spelling" && assessment_type[3] != "grammar") {
      return (
        <Scale scaleTo={2500}>
          <SummerBlock
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>)
    } else if (assessment_type[2].toLowerCase() == "autumn" && assessment_type[3] == "ar") {
      return (
        <Scale scaleTo={2500}>
          <AutumnAr
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    } else if (assessment_type[2].toLowerCase() == "autumn" && assessment_type[3] == "re") {
      return (
        <Scale scaleTo={2500}>
          <AutumnRe
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    } else if (assessment_type[2].toLowerCase() == "autumn" && assessment_type[3] != "spelling" && assessment_type[3] != "grammar") {
      return (
        <Scale scaleTo={2500}>
          <AutumnBlock
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>)
    } else if (assessment_type[2].toLowerCase() == "spring" && assessment_type[3] == "ar") {
      return (
        <Scale scaleTo={2500}>
          <SpringAr
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    }
    else if (assessment_type[2].toLowerCase() == "spring" && assessment_type[3] == "re") {
      return (
        <Scale scaleTo={2500}>
          <SpringRe
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    }
    else if (assessment_type[2].toLowerCase() == "spring" && assessment_type[3] != "spelling" && assessment_type[3] != "grammar") {
      return (
        <Scale scaleTo={2500}>
          <SpringBlock
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>)
    }
    else if (assessment_type[3].toLowerCase() == "grammar" || assessment_type[3].toLowerCase() == "spelling") {
      return (
        <Scale scaleTo={2500}>
          <Spag
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    }
    else if (assessment_type[2].toLowerCase() == "progress") {
      return (
        <Scale scaleTo={2500}>
          <ReadyToProgress
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    }
    else if (assessment_type[3] == "outwood") {
      return (
        <Scale scaleTo={2500}>
          <SpagOutwood
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    }
    else if (assessment_type.includes("arithmetic")) {
      return (
        <Scale scaleTo={2500}>
          <Arithmetic
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    }
    else if (assessment_type.includes("ks1fixed")) {
      return (
        <Scale scaleTo={2500}>
          <KS1Fixed
            game={props.game}
            homework={props.homework}
            assessment_type={assessment_type}
            onBack={() => {
              navigate(`/games/`);
            }}
          /></Scale>
      )
    }
    return "testing123";
  }

  console.log(props);


  return (
    <div>
      {GetType()}
    </div>
  );
}

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`